import closeIcon from "../../icons/close.svg";
import attentionBigIcon from "../../icons/attention-big.svg";
import codeIcon from "../../icons/code.svg";
import visaIcon from "../../icons/visa.png";
import mastercardIcon from "../../icons/mastercard.png";
import mirIcon from "../../icons/mir.svg";

const DuplicateOrderConfirmationDialog = ({payWithIgnoreOrderDuplication, onClose}) => {
    return <div>
        <div style={{background: "#0000004D", position: "fixed", top: 0, left: 0, right: 0, bottom: 0}}></div>
        <div style={{
            background: "white",
            position: "fixed",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            left: 0,
            right: 0,
            bottom: 0,
            height: 284,
            zIndex: 9999
        }}>
            <button
                style={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    padding: 8,
                    border: 0,
                    background: "#F1F1F1",
                    borderRadius: 8
                }}>
                <img src={closeIcon} style={{display: "block"}} onClick={onClose}/>
            </button>
            <div style={{textAlign: "center", marginTop: 42}}>
                <img src={attentionBigIcon}/>
                <div style={{
                    fontSize: 22,
                    fontWeight: 600,
                    marginTop: 4,
                    letterSpacing: "-0.018em"
                }}>Заказ на этот маршрут уже есть
                    <div style={{fontSize: 14, fontWeight: 400}}>Оплатить еще один билет?</div>
                </div>
                <div style={{
                    display: "flex",
                    gap: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
                    justifyContent: "center",
                    marginTop: 32
                }}>
                    <button onClick={onClose} style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: 0,
                        borderRadius: 10,
                        width: "100%",
                        height: 48,
                        color: "#1BA136",
                        background: "#1414140F"
                    }}>Нет
                    </button>
                    <button onClick={() => payWithIgnoreOrderDuplication()} style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: 0,
                        borderRadius: 10,
                        width: "100%",
                        height: 48,
                        color: "#1BA136",
                        background: "#1414140F"
                    }}>Да
                    </button>
                </div>
            </div>

        </div>
    </div>
}

const Unblocking = ({unblockCode,setUnblockCode,pay,error}) => {
    return <div style={{width: "100%"}}>
        <img alt={""} src={codeIcon} style={{width: "50%", marginTop: 56, marginBottom: 16}}/>
        <div style={{fontSize: 22, fontWeight: 500, lineHeight: "28px"}}>Проверка оплаты контролёром</div>
        <div style={{
            fontWeight: 400,
            fontSize: 15,
            lineHeight: "20px",
            letterSpacing: "-0.02em",
            color: "#898989",
            marginBottom: 8
        }}>Для завершения оплаты введите код с устройства контролёра
        </div>
        <input type={"number"}
               autoFocus
               value={unblockCode || ""}
               onChange={e => setUnblockCode(e.target.value)}
               style={{
                   width: "calc(100% - 31px)",
                   background: "#1414140F",
                   borderRadius: 12,
                   fontSize: 16,
                   paddingTop: 13,
                   paddingRight: 16,
                   paddingBottom: 15,
                   paddingLeft: 16,
                   borderWidth: 2,
                   borderStyle: "solid",
                   borderColor: error ? "#F5373C" : "silver"
               }}/>
        {error && <div style={{
            marginTop: 7,
            fontSize: 13,
            color: "#F5373C",
            marginLeft: 8,
        }}>Неверный код. Введите снова
        </div>}

        <button className={"payment-button"}
                onClick={()=>{
                    pay()
                }}
            // disabled={unblockCode?.length === 0}
                style={{position: "fixed", bottom: 16, width: "calc(100% - 31px)"}}>Оплатить
        </button>
    </div>
}

const Price = ({vehicle, cards, showCards, price, disabled, pay}) => <div style={{display: "flex", gap: 8}}>
    {!disabled && vehicle && cards.length > 0 && <div onClick={showCards} style={{
        background: "#1414140F",
        paddingTop: 8,
        borderRadius: 10,
        minWidth: 80,
        fontSize: 13
    }}>
        {cards[0].pan[0] === "4" && <img alt={"Visa"} style={{height: 12}} src={visaIcon}/>}
        {cards[0].pan[0] === "5" &&
            <img alt={"MasterCard"} style={{height: 12}} src={mastercardIcon}/>}
        {cards[0].pan[0] === "2" && <img alt={"МИР"} style={{height: 12}} src={mirIcon}/>}
        <div style={{color: "#898989"}}>····&nbsp;{cards[0].pan.slice(-4)}</div>
    </div>}
    <div style={{width: "100%"}}>
        <button className={"payment-button"} disabled={disabled} onClick={e => pay()}>
            <span>{cards.length > 0 ? "Оплатить" : "К Оплате"}</span>{price !== null ?
            <span> · {price / 100} ₽</span> : null}
        </button>
    </div>
</div>


export {DuplicateOrderConfirmationDialog, Price, Unblocking}